import { useCallback, useState, useRef } from 'react'
import { useAppDispatch, useAppSelector } from '../../reducers/store'
import {
  storeSetSnapshot,
  storeInitializeSnapshot,
} from '../../reducers/snapshot.reducer'
import { SnapshotFactory, Snapshot } from './snapshot.factory'
import { TimeLine } from '../../generated/graphql'

export const useSnapshotStore = () => {
  const dispatch = useAppDispatch()
  const { nodeId, snapshot } = useAppSelector((state) => state.snapshot)
  const [loading, setLoading] = useState(false)

  /**
   * Alias functions for the reducer
   */
  const initialize = useCallback(
    (data: { nodeId: string; tick: number }) => {
      dispatch(storeInitializeSnapshot(data))
    },
    [dispatch]
  )

  /**
   * Regenerate Snapshot from items
   * when the index changes or the items are loaded
   */
  const setSnapshotTick = useCallback(
    (items: TimeLine[], currentIndex: number) => {
      if (!snapshot) {
        return
      }
      if (currentIndex >= items.length) {
        // Will wait the items are updateds
        setLoading(true)
        return
      }

      setLoading(false)

      let updatedSnapshot = { ...snapshot }
      // For some reason the initial snapshot is not set
      if (snapshot.tick === 0 && currentIndex === 0 && !snapshot.node.id) {
        updatedSnapshot = SnapshotFactory.increase(snapshot, items[0])
        updatedSnapshot.tick = 0
      }
      // Move forward
      if (snapshot.tick < currentIndex) {
        updatedSnapshot = items
          .slice(snapshot.tick + 1, currentIndex + 1)
          .reduce((acc, item) => {
            return SnapshotFactory.increase(acc, item)
          }, updatedSnapshot)
      }

      // Move backward (init is -1) current ticket is already loaded
      if (snapshot.tick > currentIndex) {
        updatedSnapshot = items
          .slice(0, currentIndex + 1)
          .reduce((acc, item) => {
            return SnapshotFactory.increase(acc, item)
          }, new Snapshot().toObject())
      }
      dispatch(storeSetSnapshot(updatedSnapshot))
    },
    [snapshot, dispatch]
  )

  return {
    nodeId,
    snapshot,
    loading,
    initialize,
    setSnapshotTick,
  }
}
